import { Items } from "@pdfking/tfunc"

import { ordered_object } from "./ordered_object"

export const merge = (...args) =>
  ordered_object(args.reduce((a, b) => a.concat(Items(b)), []))
